<template>
  <header>
    <TheNavbar />
    <TheRemainingDaysStripe v-if="emailVerified & !buyingProcess" />
  </header>
</template>

<script>
import TheNavbar from "./header/TheNavbar";
import TheRemainingDaysStripe from "./header/TheRemainingDaysStripe";
import { mapGetters } from "vuex";
export default {
  name: "TheHeader",
  components: { TheRemainingDaysStripe, TheNavbar },
  computed: {
    ...mapGetters({
      emailVerified: "user/isEmailVerified",
    }),
    buyingProcess() {
      if (this.$route.name === "membership.extend.30") return true;
      else if (this.$route.name === "membership.extend.360") return true;
      return false;
    },
  },
};
</script>

<style scoped></style>
